import Immutable from 'immutable';

import StudentPaperBasedHomework from './model';
import { covertBackendPaperBasedHomeworkStatusToHomeworkStatus as convertStatus } from '../status';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
    case 'studentId':
      return [key, `${val}`];  // stringify
    case 'homeworkStatus':
      return [key, convertStatus(val)];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

export const create = (data) =>
  new StudentPaperBasedHomework(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/PaperBasedHomework/StudentPaperBasedHomework/create.js